exports.decode = exports.parse = require("./decode");
exports.encode = exports.stringify = require("./encode");
